import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { ContentMessage } from 'axway-react-ui';
import IntlComponent from 'axway-react-intl';

class InvalidFlowPanel extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.onAction = this.onAction.bind(this);
	}

	onAction() {
		const { action } = this.props;
		action && action();
	}

	render() {
		const summaryDiv = (
			<div>
				<p>{this.intl.formatMsg('Oops! This flow seems to be corrupted.')}</p>
				<p>{this.intl.formatMsg('Please look at the server logs and correct all issues before editing the flow in the UI.')}</p>
			</div>
		);
		return (
			<div className="invalid-flow-panel">
				<ContentMessage
					inlineContent
					confirm
					actionClass="btn-primary"
					summary={summaryDiv}
					className="lg warning"
					imgClass="gg icon-GG-warning"
					onAction={this.onAction}
					actionLabel={this.intl.formatMsg('Go to documentation')}
				/>
			</div>
		);
	}
}

InvalidFlowPanel.propTypes = {
	action: PropTypes.func.isRequired
};

export default injectIntl(InvalidFlowPanel);
